var map = {
	"./bear1.png": "5f0f",
	"./bear2.png": "8d6a",
	"./bear3.png": "3582",
	"./bear4.png": "5c61",
	"./bear5.png": "edb5",
	"./bear6.png": "c012",
	"./bear7.png": "89ae",
	"./bear8.png": "82ec",
	"./bear9.png": "5285"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4391";